import React from 'react'
import { useIntl } from 'react-intl'
import cn from 'classnames'

import Price from 'client/components/Price'

import IconCheckmark from 'client/icons/Checkmark'

import styles from '../styles.module.css'
import DateIntl from 'src/comps/DateIntl'
import { DATE_INTL_FORMAT_MONTH_TEXT } from 'src/comps/DateIntl/constants'

interface Cancellation {
  amount: number
  from: string
  currency: string
}

export interface RateProps {
  cancellation: Cancellation
  currency: string
  payRate: number
}

export interface RatePaymentProps {
  cancellationDate: JSX.Element
  payRate: number
  currency: string
}

export const RateSFLPayment = ({ cancellationDate, payRate, currency }: RatePaymentProps) => {
  const intl = useIntl()
  return (
    <>
      <li className={cn(styles.greenText, styles.listDoted)}>
        <IconCheckmark size={16} />
        {intl.formatMessage(
          { id: 'room.pay-partial' },
          { pay_rate: <Price amount={payRate} currency={currency} /> }
        )}
        {` (${intl.formatMessage({ id: 'policies.deposit' })})`}
      </li>

      <li className={cn(styles.greenText, styles.listDoted)}>
        <IconCheckmark size={16} />
        {intl.formatMessage({ id: 'policies.pay-the-rest-on' }, { date: cancellationDate })}
      </li>
    </>
  )
}

export const RateSFLPaymentDescription = ({ cancellation, payRate, currency }: RateProps) => {
  const intl = useIntl()

  const cancellationDate = (
    <DateIntl value={cancellation?.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateSFLPayment payRate={payRate} currency={currency} cancellationDate={cancellationDate} />
      </ul>
      <p>
        {intl.formatMessage(
          { id: 'payment.deposit' },
          { price: <Price amount={payRate} currency={currency} /> }
        )}
      </p>
    </>
  )
}

export const RateSFLCancelation = ({ cancellationDate }: { cancellationDate: JSX.Element }) => {
  const intl = useIntl()

  return (
    <li className={styles.greenText}>
      <IconCheckmark size={16} />
      <p>
        {intl.formatMessage({ id: 'policies.cancel-until' }, { date: cancellationDate })}
        <span className={styles.boldBlack}>{` (${intl.formatMessage({
          id: 'policies.deposit-non-refundable',
        })})`}</span>
      </p>
    </li>
  )
}

export const RateSFLCancellationDescription = ({ cancellation, payRate, currency }: RateProps) => {
  const intl = useIntl()

  const cancellationDate = (
    <DateIntl value={cancellation?.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return (
    <>
      <ul className={styles.offerConditionsList}>
        <RateSFLCancelation cancellationDate={cancellationDate} />
      </ul>
      <p>
        {intl.formatMessage(
          { id: 'payment.cancel-for-free-slf' },
          { date: cancellationDate, amount: <Price amount={payRate} currency={currency} /> }
        )}
      </p>
    </>
  )
}

const RateSFL = ({ cancellation, payRate, currency }: RateProps) => {
  const cancellationDate = (
    <DateIntl value={cancellation.from} format={DATE_INTL_FORMAT_MONTH_TEXT} />
  )

  return (
    <>
      <RateSFLPayment payRate={payRate} currency={currency} cancellationDate={cancellationDate} />
      <RateSFLCancelation cancellationDate={cancellationDate} />
    </>
  )
}

export default RateSFL
